import React from 'react'
import { useRequiredAgreements } from '../../hooks/useRequiredAgreements';
import { AgreementsModal } from '../../pages/AgreementsModal/AgreementsModal';
import { Modal } from './Modal';

interface Props {
    children: React.ReactNode;
}

export const AgreementsProvider = ({ children }: Props) => {
    const { handleCloseModal, modal } = useRequiredAgreements();

    return (
        <>
            {children}
            <Modal canclose={false} ref={modal}>
                <AgreementsModal onClose={handleCloseModal} />
            </Modal>
        </>

    )
}
